import { useEffect, useState } from "react";
import Modal from "../Modal";
import ErrorHandling from "shared/ErrorHandling";
import Button from "shared/Button";
import moment from "moment";
import CustomDatePicker from "shared/inputs/CustomDatePicker";
import { useDispatch } from "react-redux";
import { rescheduleDelivery } from "app/subscriptions/actions";
import { useStripe } from "@stripe/react-stripe-js";

export default function RescheduleFailingSubscriptionModal({
  isOpen,
  onClose,
  subscriptionId
}) {
  const dispatch = useDispatch();
  const stripe = useStripe();

  const minDate = moment().add(1, "day").startOf("day").toDate();
  const maxDate = moment().add(3, "month").startOf("day").toDate();

  const [nextDate, setNextDate] = useState(minDate);

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [successState, setSuccessState] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (isOpen) {
      setError(null);
      setSuccessState(null);
    }
  }, [isOpen]);

  return (
    <Modal
      isOpen={isOpen}
      handleClose={onClose}
      title="Schedule next payment attempt"
      subtitle="Let us know when you'd like us to retry payment for your subscription."
      successState={successState}
    >
      <CustomDatePicker
        value={nextDate}
        onChange={setNextDate}
        minDate={minDate}
        maxDate={maxDate}
      />
      <ErrorHandling error={error} />
      <div className="mt-4">
        <Button
          isLoading={isSubmitting}
          onClick={async () => {
            setIsSubmitting(true);

            try {
              await dispatch(
                rescheduleDelivery(
                  subscriptionId,
                  { next_date: nextDate },
                  stripe
                )
              );
              setSuccessState({
                title: "Your next payment attempt has been scheduled."
              });
            } catch (error) {
              setError(error);
            } finally {
              setIsSubmitting(false);
            }
          }}
        >
          Schedule
        </Button>
        <Button btnType="tertiary" className="ms-3" onClick={onClose}>
          Cancel
        </Button>
      </div>
    </Modal>
  );
}
